/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import mbpLogger from 'mbp-logger';
import { string } from 'prop-types';

import { useDispatch, useSelector } from 'react-redux';

import { setModalQasRadioButtonsSaleForceABTest } from '../../../../../../../state/ducks/MfeCheckout/ducks/App/App-Actions';
import useSalesforcePersonalizedContentQuery from '../../../../../../helpers/Personalization/useSalesforcePersonalizedContentQuery';
import { getModalQasRadioBtnSFABTest } from '../../../../../../../state/ducks/MfeCheckout/ducks/App/App-Selectors';

const ModalQasRadioButtonsABTest = ({ pageType }) => {
    const dispatch = useDispatch();
    const modalRadioButtonsSFABTestData = useSelector(getModalQasRadioBtnSFABTest);

    const { loading, data, error } = useSalesforcePersonalizedContentQuery({
        interactionName: 'Get Campaign - QAS Modal UI Update',
        targeting: { pageType },
        featureFlag: true,
        apolloOptions: {
            fetchPolicy: 'cache-first',
        },
        optInHoldoutParticipation: false,
        resolveIdentity: false,
    });

    if ((loading) || (!loading && !data && !error)) {
        return null;
    }

    if (error) {
        mbpLogger.logError({
            function: 'ModalQasRadioButtonsABTest',
            appName: process.env.npm_package_name,
            module: 'mbp-checkout',
            message: 'ModalQas Radio Buttons Salesforce AB test returned an error',
            jsError: error,
        });
    }

    if (
        data?.contentSF?.campaign?.campaignResponses?.[0]?.userGroup
        && data?.contentSF?.campaign?.campaignResponses?.[0]?.userGroup !== modalRadioButtonsSFABTestData?.campaign?.campaignResponses?.[0]?.userGroup
    ) {
        dispatch(setModalQasRadioButtonsSaleForceABTest(data.contentSF));
    }

    return null;
};

ModalQasRadioButtonsABTest.propTypes = {
    pageType: string.isRequired,
};

export default ModalQasRadioButtonsABTest;
